import { classSystemKeys } from "src/common/systemKey";

import { attrsRecordInternalToRaw } from "../attribute/values/attrValueInternalToRaw";
import { ZSpecification } from "../specification";
import { ZSecSpecRow } from "../specification/ZSecSpecRow";
import { zClassSysData } from "./ZClassSysData";
import { ZClassUpdate, ZSecondSpecUpdate } from "./ZClassUpdate";

export const makeClassRawData = (
  internalValues: unknown,
  schemes: ZSpecification[],
): ZClassUpdate => {
  if (!internalValues || typeof internalValues !== "object") {
    throw Error("Invalid internalValues in makeClassRawData");
  }

  const sys = zClassSysData.safeParse(internalValues);
  if (!sys.success) {
    throw Error("Invalid sys.name in makeClassRawData");
  }

  const parentIds = sys.data[classSystemKeys.secondParents].parentIds ?? [];

  const cvtSecondSpec = (spec: ZSecSpecRow): ZSecondSpecUpdate => ({
    schemaId: spec.id,
    linkTypeCode: spec.linkType.code,
    catalogIds: spec.catalogs?.map(({ id }) => id),
  });

  const result: ZClassUpdate = {
    parentIds,
    // TODO: Такого быть не должно. Но похоже что сейчас отсутствует заполнение name на бэке. И без этого костыля формируются данные без label, что нарушает валидацию данных
    // Нужно будет поле из типа, когда бэк будет правильно формировать name по displayAttribute
    name: `class ${sys.data[classSystemKeys.first].displayId}`,
    data: {},
    secondarySchemas:
      sys.data[classSystemKeys.secondarySpecs]?.map(cvtSecondSpec) ?? [],
  };
  schemes.forEach((scheme) => {
    const part = (internalValues as Record<string, unknown>)[scheme.name];
    const attributes = scheme.definition?.attributes;
    if (part && typeof part === "object" && attributes) {
      result.data[scheme.name] = attrsRecordInternalToRaw(
        part as Record<string, unknown>,
        attributes,
      );
    }
  });
  return result;
};
